module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1046-145ff58aa9182fb0f1a6b2aba058782e.png";